import React from 'react';

function AuthLayout({ children }) {
  return (
    <div style={{ minHeight: '100vh', background: '#0d1825', color: '#fff', display: 'flex', alignItems: 'stretch', justifyContent: 'center', padding: 0 }}>
      <div style={{ width: '100%' }}>{children}</div>
    </div>
  );
}

export default AuthLayout;
